var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExclamation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_49515",
    "data-name": "Path 49515",
    d: "M7,0a7,7,0,1,0,7,7A7,7,0,0,0,7,0Zm.719,9.779c0,.221-.322.442-.719.442-.415,0-.709-.221-.709-.442V6.268c0-.258.295-.433.709-.433.4,0,.719.175.719.433V9.779ZM7,4.987a.721.721,0,0,1-.756-.663A.714.714,0,0,1,7,3.67a.711.711,0,0,1,.746.654A.718.718,0,0,1,7,4.987Z",
    transform: "translate(0 0)",
    fill: "#80838e"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamation);
export default __webpack_public_path__ + "static/media/exclamation.e4a5d88171e21b2a4caa9081bf34b114.svg";
export { ForwardRef as ReactComponent };